'use client'

import { usePathname } from 'next/navigation'
import { useCallback, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'

import { useNotificationSocket } from '@features/websocket/hooks/useNotificationSocket'
import { socketConfigs } from '@features/websocket/socketConfigs'
import { initSocketService, registerConfigs, cleanupAll } from '@features/websocket/socketService'
import { setCurrentPath, initConfigs, type SocketConfigLite } from '@store/modules/sockets/slice'

export default function SocketRouteBridgePages() {
  useNotificationSocket()
  const isMounted = useRef(false)
  const pathname = usePathname()
  const dispatch = useDispatch()

  const initSocket = useCallback(() => {
    if (isMounted.current) return
    isMounted.current = true

    initSocketService(dispatch)
    registerConfigs(socketConfigs)

    dispatch(
      initConfigs(
        socketConfigs.map(({ name, match, url }) => ({
          name,
          url,
          match: (Array.isArray(match) ? match : [match]).map((m: string | RegExp) =>
            m instanceof RegExp ? m.toString() : m,
          ),
        })) as SocketConfigLite[],
      ),
    )
  }, [dispatch])

  const handleBrowserRouteChange = useCallback(() => {
    dispatch(setCurrentPath(pathname))
  }, [dispatch, pathname])

  useEffect(() => {
    initSocket()

    return () => {
      isMounted.current = false
      cleanupAll()
    }
  }, [initSocket])

  useEffect(() => {
    handleBrowserRouteChange()
  }, [handleBrowserRouteChange])

  return null
}
